import { HighlightContentExtension } from "@tiptap-content/extensions/highlight/highlight-content-extension"
import { HIGHLIGHT_COLOR_MAP, MARK_COLORS } from "@tiptap-content/util/colors"
import type { Slice } from "@tiptap/pm/model"
import { Plugin } from "@tiptap/pm/state"
import { clampColor } from "../../util/clamp-color"

/** The allowed highlight colors. */
export const HIGHLIGHT_COLORS: { name: string; color: string }[] = MARK_COLORS.map((name) => ({
  name: name[0]!.toUpperCase() + name.slice(1),
  color: HIGHLIGHT_COLOR_MAP[name],
}))

// Cp mod: Clamp highlight colors to our allowed list when pasting.
export const CpHighlight = HighlightContentExtension.extend({
  addProseMirrorPlugins() {
    return [...(this.parent?.() ?? []), new Plugin({ props: { transformPasted } })]
  },
})

function transformPasted(slice: Slice): Slice {
  slice.content.descendants((node) => {
    for (const mark of node.marks) {
      if (mark.type.name === "highlight" && mark.attrs["color"]) {
        const clamped = clampColor(
          HIGHLIGHT_COLORS.map((entry) => entry.color),
          mark.attrs["color"] as string,
          // Highlight pastels are low-saturation, so only treat near-grays as
          // achromatic.
          0.05,
        )
        // Mutating mark attrs directly for paste-transform convenience; marks
        // are nominally immutable but this is safe inside transformPasted.
        // @ts-expect-error mark.attrs has no index signature
        mark.attrs = { ...mark.attrs, color: clamped }
      }
    }
  })
  return slice
}
